import { Box, Button, Dialog, DialogActions, DialogTitle, DialogContent, Grid, IconButton, Typography, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react';
import useTranslations from '../Translations/useTranslations';
import AnimationSlideRight from "../../Animation/AnimationSlideRight";
import AnimationSlideLeft from "../../Animation/AnimationSlideLeft";
import { fetchData } from '../../BaseUrl';
import Routings from '../../Routings';
import { useLocation, useNavigate } from 'react-router-dom';
import { Close } from '@mui/icons-material';

const Biliteracy = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:600px)");
  const [registerModalOpen, setRegisterModalOpen] = useState(false);
  const [biliterancy, setBiliterancy] = useState([]);
  const [verifyErrors, setVerifyErrors] = useState({});
  const [verifyApiError, setVerifyApiError] = useState("");
  const [verifyOpen, setVerifyOpen] = useState(false);
  const [verifyForm, setVerifyForm] = useState({
    registrationNumber: "",
    parentEmail1: "",
    parentEmail2: "",
  });
  useTranslations();

  const handleRedirect = () => {
    if (location.pathname === Routings.STUDENT_REGISTRATION) {
      setRegisterModalOpen(false);
    } else {
      setRegisterModalOpen(true);
    }
  };

  const openVerifyModal = () => {
    setRegisterModalOpen(false);
    setVerifyForm({ registrationNumber: "", parentEmail1: "", parentEmail2: "" });
    setVerifyErrors({});
    setVerifyApiError("");
    setVerifyOpen(true);
  };

  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#f9f5ff",
      padding: isMobile ? "1rem" : "2rem 4rem",
    },
    heading: {
      fontSize: isMobile ? "22px" : "30px",
      fontWeight: "bold",
      color: "#000",
      marginBottom: "10px",
      textAlign: "left",
    },
    subheading: {
      fontSize: isMobile ? "14px" : "16px",
      color: "#333",
      marginBottom: "20px",
      textAlign: "left",
    },
    imageContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      paddingRight: isMobile ? "10px" : "30px",
    },
    image: {
      width: isMobile ? "80%" : "60%",
      height: "auto",
      maxWidth: "250px",
      maxHeight: "250px",
      borderRadius: "8px",
    },
  };

  useEffect(() => {
    getBiliterancy();
  }, []);

  const getBiliterancy = async () => {
    try {
      const response = await fetchData("/admin/seal-of-biliteracy/list-contents");
      if (response?.data?.length) {
        setBiliterancy(response.data);
      } else {
        setBiliterancy([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setBiliterancy([]);
    }
  };

  return (
    <div style={{ paddingTop: "6rem", minHeight: "60vh" }}>
      <Box sx={styles.container}>
          {biliterancy.length > 0 ? (
            biliterancy.map((item, index) => (
            <Grid container spacing={4}>
              <React.Fragment key={item.id}>
                {/* Left Side: Text Content */}
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <AnimationSlideLeft duration={1.4} rootMargin={"-10px"}>
                    <Box sx={{ p: 4 }}>
                      <Typography sx={styles.heading}>Biliteracy Award</Typography>
                      <Typography sx={styles.subheading}>
                        Recognizing outstanding achievement in biliteracy.
                      </Typography>
                    </Box>
                  </AnimationSlideLeft>
                </Grid>

                {/* Right Side: Image (Only if type is "img") */}
                <Grid item xs={12} md={6} p={2}>
                  <AnimationSlideRight duration={1.4} rootMargin={"-10px"}>
                    <Box sx={styles.imageContainer}>
                      {item.type === "img" && item.content ? (
                        <img
                          src={item.content}
                          style={styles.image}
                          alt="Biliteracy Certificate"
                        />
                      ) : (
                        <Typography>No Image Available</Typography>
                      )}
                    </Box>
                  </AnimationSlideRight>
                </Grid>
              </React.Fragment>              
            </Grid>
            ))
          ) : (
            <Box mt={2}>
              <Typography sx={{ fontSize: 28, fontWeight: "bold", textAlign: "left", mb: 3 }}>
                Seal Of Bi-Literacy
              </Typography>
              <Box style={{ display: "flex", flexDirection: "column", alignItems: "left", gap: 2, width: "100%" }}>
                <Button
                  size="large"
                  onClick={handleRedirect}
                  sx={{
                    backgroundColor: "#153fc9",
                    color: "#fff",
                    fontWeight: "bold",
                    px: 4,
                    animation: "pulse 1.5s infinite",

                    "@keyframes pulse": {
                      "0%": {
                        boxShadow: "0 0 0 0 rgba(21, 63, 201, 0.7)",
                      },
                      "70%": {
                        boxShadow: "0 0 0 12px rgba(21, 63, 201, 0)",
                      },
                      "100%": {
                        boxShadow: "0 0 0 0 rgba(21, 63, 201, 0)",
                      },
                    },

                    "&:hover": {
                      backgroundColor: "#153fc9",
                    },
                  }}
                >
                  Register Now
                </Button>
              </Box>
            </Box>

          )}
      </Box>
      <Dialog
        open={registerModalOpen}
        onClose={() => setRegisterModalOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ sx: { borderRadius: "16px", p: 1 } }}
      >
        <IconButton
          onClick={() => setRegisterModalOpen(false)}
          sx={{ position: "absolute", top: 8, right: 8, color: "#9CA3AF" }}
        >
          <Close/>
        </IconButton>
        <DialogTitle sx={{ textAlign: "center", fontWeight: 700, fontSize: "20px", color: "#3B4E8C", pt: 4, lineHeight: 1.4 }}>
          Are you a new student<br />or an existing student?
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ textAlign: "center", color: "#6B7280", fontSize: "14px" }}>
            Please select an option to continue your registration.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", gap: 2, pb: 3, px: 3 }}>
          <Button
            variant="contained"
            onClick={() => {
              setRegisterModalOpen(false);
              navigate(Routings.STUDENT_REGISTRATION, {
                state: { studentType: "new" },
              });
            }}
            sx={{
              backgroundColor: "#3B4E8C",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              "&:hover": { backgroundColor: "#2d3d6e" },
            }}
          >
            New Student
          </Button>

          <Button
            variant="outlined"
            onClick={() => {
              setRegisterModalOpen(false);
              navigate(Routings.STUDENT_REGISTRATION, {
                state: { studentType: "old" },
              });
            }}
            sx={{
              borderColor: "#3B4E8C",
              color: "#3B4E8C",
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              "&:hover": { backgroundColor: "#f0f2f8" },
            }}
          >
            Existing Student
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Biliteracy;
